// Auto-generated by scripts/generate-registry.mjs from packages/modules/mini_electronic_candle_lamp/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const mini_electronic_candle_lamp: ModuleSchema = {
  "id": "mini_electronic_candle_lamp",
  "uniqueId": "B3D_UPH5L",
  "createdAt": "2026-10-08T00:00:00Z",
  "updatedAt": "2026-10-14T00:30:28.015Z",
  "label": "Candle Wave",
  "description": "A two-part mini candle lamp with a screw-on slotted shade, reusable electronic-candle base, and adjustable print-fit thread clearance.",
  "category": "lighting",
  "tags": [
    "lamp",
    "mini",
    "electronic-candle",
    "wavy",
    "bambu-inspired"
  ],
  "sliders": [
    {
      "key": "baseDiameter",
      "label": "Base Maximum Diameter",
      "min": 50,
      "max": 90,
      "step": 1,
      "default": 65,
      "unit": "mm",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "baseHeight",
      "label": "Base Height",
      "min": 20,
      "max": 50,
      "step": 1,
      "default": 26,
      "unit": "mm",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "threadRadialClearance",
      "label": "Thread Radial Clearance",
      "min": 0.3,
      "max": 0.8,
      "step": 0.05,
      "default": 0.45,
      "unit": "mm",
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "candleDiameter",
      "label": "Electronic Candle Diameter",
      "min": 12,
      "max": 60,
      "step": 0.5,
      "default": 38,
      "unit": "mm",
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "candleSocketDepth",
      "label": "Candle Socket Depth",
      "min": 8,
      "max": 24,
      "step": 0.5,
      "default": 22.5,
      "unit": "mm",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "baseWallThickness",
      "label": "Base Socket Wall Thickness",
      "min": 1,
      "max": 6,
      "step": 0.2,
      "default": 2.4,
      "unit": "mm",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "baseFloorThickness",
      "label": "Base Floor Thickness",
      "min": 1,
      "max": 8,
      "step": 0.2,
      "default": 2.4,
      "unit": "mm",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "baseWaveDepth",
      "label": "Base Wave Relief",
      "min": 0,
      "max": 3,
      "step": 0.1,
      "default": 1.5,
      "unit": "mm",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "baseFluteCount",
      "label": "Base Vertical Flute Count",
      "min": 0,
      "max": 36,
      "step": 2,
      "default": 36,
      "unit": "flutes",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "baseFluteDepth",
      "label": "Base Flute Relief",
      "min": 0,
      "max": 1.8,
      "step": 0.1,
      "default": 1.2,
      "unit": "mm",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "shadeHeight",
      "label": "Shade Height",
      "min": 40,
      "max": 100,
      "step": 1,
      "default": 74,
      "unit": "mm",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeMaxDiameter",
      "label": "Shade Maximum Diameter",
      "min": 55,
      "max": 80,
      "step": 1,
      "default": 67,
      "unit": "mm",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeTroughDiameter",
      "label": "Shade Trough Diameter",
      "min": 48,
      "max": 65,
      "step": 1,
      "default": 59,
      "unit": "mm",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeWaveCount",
      "label": "Shade Wave Lobes",
      "min": 2,
      "max": 6,
      "step": 1,
      "default": 3,
      "unit": "lobes",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeFluteCount",
      "label": "Shade Vertical Rib Count",
      "min": 0,
      "max": 48,
      "step": 2,
      "default": 36,
      "unit": "ribs",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeFluteDepth",
      "label": "Shade Rib Definition",
      "min": 0,
      "max": 2.5,
      "step": 0.1,
      "default": 2,
      "unit": "mm",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeGapWidth",
      "label": "Open Shade Gap Width",
      "min": 0.4,
      "max": 2,
      "step": 0.1,
      "default": 0.9,
      "unit": "mm",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeWallThickness",
      "label": "Shade Wall Thickness",
      "min": 0.8,
      "max": 2.5,
      "step": 0.1,
      "default": 1.5,
      "unit": "mm",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeShelfThickness",
      "label": "Inner Pad Thickness",
      "min": 0.8,
      "max": 3.1,
      "step": 0.1,
      "default": 2,
      "unit": "mm",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeWaistBandHeight",
      "label": "Shade Waist Band Height",
      "min": 0,
      "max": 6,
      "step": 0.2,
      "default": 2,
      "unit": "mm",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "candle_base",
      "label": "Electronic Candle Base",
      "default": "#76D7B8",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "wavy_shade",
      "label": "Three-Lobe Wavy Shade",
      "default": "#176A78",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "mini_candle_base_obj",
      "label": "Electronic Candle Base",
      "name": "Electronic Candle Base",
      "color": "#76D7B8",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "candle_base",
          "label": "Electronic Candle Base",
          "name": "Electronic Candle Base",
          "groupId": 1,
          "colorKey": "candle_base",
          "defaultColor": "#76D7B8",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "mini_wavy_shade_obj",
      "label": "Three-Lobe Wavy Shade",
      "name": "Three-Lobe Wavy Shade",
      "color": "#176A78",
      "assembled_z_offset": 0,
      "exploded_z_offset": 35,
      "parts": [
        {
          "id": "wavy_shade",
          "label": "Three-Lobe Wavy Shade",
          "name": "Three-Lobe Wavy Shade",
          "groupId": 0,
          "colorKey": "wavy_shade",
          "defaultColor": "#176A78",
          "assembled_z_offset": 0,
          "exploded_z_offset": 35,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "assembly",
      "label": "Full Mini Lamp",
      "targetGroupId": -1,
      "default": true
    },
    {
      "id": "base",
      "label": "Electronic Candle Base Only",
      "targetGroupId": 1
    },
    {
      "id": "shade",
      "label": "Wavy Shade Only",
      "targetGroupId": 0
    }
  ]
};
